import React, { useEffect, useRef, useState } from 'react';
import ChatBubble from '../Components/Chatbubble';
import MessageInput from '../Components/MessageInput';
import TypingDots from '../Components/TypingDots';
import aiAvatar from '../Assets/kumar-avatar.png';
import userAvatar from '../Assets/User-avatar.png';
import { useLocation } from 'react-router-dom';
import { callOpenAI } from '../utils/openaiService';

const Chat = () => {
  const location = useLocation();
  const chatContainerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const [messages, setMessages] = useState([
    {
      sender: 'ai',
      avatar: aiAvatar,
      name: 'Kumar',
      message: `Yo! I’m Kumar — your career wingman 😎  
Lost? Confused? Overwhelmed? Don’t worry.  
We’ll figure this out — one step at a time.  
Tell me where you are right now, and I’ll help you take the next best step. 🚀`,
      timestamp: new Date().toLocaleString(),
    },
  ]);

  // 🧹 Start fresh on every new chat visit
  useEffect(() => {
    localStorage.removeItem('chatLog');
    localStorage.setItem('sessionStart', Date.now());
  }, []);

  // 🧼 Auto-scroll down
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
    localStorage.setItem('chatLog', JSON.stringify(messages)); // 🔄 Optional save
  }, [messages, isLoading]);

  const handleSend = async (userText) => {
    const timestamp = new Date().toLocaleString();
    const newUserMessage = {
      sender: 'user',
      avatar: userAvatar,
      name: 'You',
      message: userText,
      timestamp,
    };

    const updatedMessages = [...messages, newUserMessage];
    setMessages(updatedMessages);
    setIsLoading(true);

    const formattedMessages = updatedMessages.map((msg) => ({
      role: msg.sender === 'ai' ? 'assistant' : 'user',
      content: msg.message,
    }));

    try {
      const aiReply = await callOpenAI({
        messages: formattedMessages,
        screenContext: 'chat', // 🧠 Pulls mentor system prompt from systemPrompts.js
      });

      const aiMessage = {
        sender: 'ai',
        avatar: aiAvatar,
        name: 'Kumar',
        message: aiReply,
        timestamp: new Date().toLocaleString(),
      };

      setMessages((prev) => [...prev, aiMessage]);
    } catch (err) {
      console.error('Error getting AI response:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-[1000px] mx-auto p-4 sm:p-6 flex flex-col justify-between h-[85vh] sm:h-[86vh] bg-white/80 rounded-[30px] shadow-xl backdrop-blur-md">
      <div className="flex flex-col gap-6 overflow-y-auto custom-scroll pr-1 flex-grow max-h-[60vh] sm:max-h-[72vh]"></div>
<div
        id="chat-container"
        ref={chatContainerRef}
        className="flex flex-col gap-6 overflow-y-auto custom-scroll pr-1 flex-grow"

      >
        {messages.map((msg, index) => (
          <ChatBubble key={index} {...msg} />
        ))}

        {isLoading && (
          <ChatBubble
            sender="ai"
            avatar={aiAvatar}
            name="Kumar"
            message={<TypingDots />}
          />
        )}
      </div>

      <div className="mt-6">
        <MessageInput onSend={handleSend} />
      </div>
    </div>
  );
};

export default Chat;
